<template>
  <div class="shop-page">
    <div class="page-header">
      <a class="fliggy-document" href="https://visagenius.feishu.cn/docx/ZUd5dnTcpo12h8xGGr4cNKgenNh?from=from_copylink" target="_blank">
        <img class="icon" src="../../../assets/imgs/new-user/icon-fliggy.png" alt="">
        <div class="text">飞猪店铺对接说明文档</div>
      </a>
      <div class="add-box" v-if="fliggyShopList.length">
        <div class="add-btn s-btn btn-blue is-plain" @click="authorize">+ 新增店铺授权</div>
      </div>
    </div>
    <template v-if="fliggyShopList.length">
      <table class="table-box" rules="groups" frame="box">
        <thead>
          <tr>
            <th width="200px">店铺名称</th>
            <th width="80px" class="text-center">飞猪授权</th>
            <th>授权到期时间</th>
            <th class="text-center">店铺状态</th>
            <th width="150px">申请人状态同步</th>
            <th class="text-center">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in fliggyShopList" :key="index">
            <td>{{item.ota_store_name}}</td>
            <td class="text-center">{{item.is_auth == 1 ? '生效中' : '失效'}}</td>
            <td class="text-center">{{item.auth_expires}}</td>
            <td class="text-center" :class="{'color-red': item.status == 0}">
              <el-switch
                class="switch-box"
                :value="item.status"
                :width="60"
                on-text="启用"
                off-text="停用"
                :on-value="1"
                :off-value="0"
                @input="fliggyChangeStatus(item)"
              >
              </el-switch>
            </td>
            <td>
              <div class="sync-status-box">
                <div class="status-text">{{syncStatusMap[item.sync_type_id]}}</div>
                <img class="edit-icon" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/icon-edit-1.png" @click="onShowSyncStatusDialog(item)" alt="">
              </div>
            </td>
            <td class="text-center">
              <div class="btn" @click="gotoOrders">查看订单</div>
              <div class="btn" @click="authorize">重新授权</div>
              <div class="btn" @click="fliggyDelete($event, item.id)">删除</div>
            </td>
          </tr>
        </tbody>
      </table>
    </template>

    <div class="nodata-box" v-else>
      <div class="nodata-title">仅需 3 步，轻松完成飞猪店铺订单同步</div>
      <div class="step-list">
        <div class="step-item">
          <img class="item-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/shop-step-1.png" alt="">
          <div class="item-text">
            免费订购<br>
            <a class="link" href="https://fuwu.taobao.com/ser/detail.htm?spm=a1z13.fuwu_search_result_2023.0.0.6a175acayMcWdI&service_code=FW_GOODS-1001016534&tracelog=search&from_key=%E4%B8%8A%E4%B8%8A%E7%AD%BE" target="_blank">上上签 ISV</a>
          </div>
        </div>
        <div class="step-item">
          <img class="item-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/shop-step-2.png" alt="">
          <div class="item-text">
            管理员开通<br>
            <a class="link" @click="authorize">飞猪店铺授权</a>
          </div>
        </div>
        <div class="step-item">
          <img class="item-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/shop-step-3.png" alt="">
          <div class="item-text">
            完成<br>
            <a class="link" href="https://loginmyseller.taobao.com/" target="_blank">飞猪SKU编码绑定</a>
          </div>
        </div>
        <div class="step-item">
          <img class="item-img" src="https://visa.oss-cn-shenzhen.aliyuncs.com/static/ssqpeer/order/fliggy/shop-step-4.png" alt="">
          <div class="item-text">
            完成<br>
            飞猪订单自动同步
          </div>
        </div>
      </div>
    </div>

    <shop-change-sync-status-dialog
      :visible.sync="syncStatusDialog.visible"
      :shop-info="syncStatusDialog.shopItem"
      @submit="onChangeSyncSuccess"
    ></shop-change-sync-status-dialog>

  </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import Http from '../../../libs/http';
import { env } from '../../../libs/env';
import { syncStatusMap } from '@/maps/fliggy-maps';
import ShopChangeSyncStatusDialog from './components/shop-change-sync-status-dialog.vue';

export default {
  components: {
    ShopChangeSyncStatusDialog,
  },
  data() {
    return {
      fliggyShopList: [],
      syncStatusMap,
      syncStatusDialog: {
        visible: false,
        shopItem: null,
      },
    };
  },
  methods: {
    // 获取飞猪店铺list
    getFliggyShopList() {
      Http.post('/peer_ota_brief_query', {})
        .then((data) => {
          this.fliggyShopList = data;
        });
    },
    authorize(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      if (env === 2) {
        window.open(`https://oauth.taobao.com/authorize?response_type=code&state=1212&client_id=26051121&redirect_uri=https://devapi.666visa.cn/www/open/alitrip_auth_callback?peer_account_id=${this.$store.state.user.userInfo.peer_account_id}#/user/shop`);
      } else if (env === 1) {
        window.open(`https://oauth.taobao.com/authorize?response_type=code&state=1212&client_id=26051121&redirect_uri=https://testapi.666visa.cn/www/open/alitrip_auth_callback?peer_account_id=${this.$store.state.user.userInfo.peer_account_id}#/user/shop`);
      } else {
        window.open(`https://oauth.taobao.com/authorize?response_type=code&state=1212&client_id=26051121&redirect_uri=https://api.666visa.cn/www/open/alitrip_auth_callback?peer_account_id=${this.$store.state.user.userInfo.peer_account_id}#/user/shop`);
      }
    },
    // 启用、停用飞猪店铺
    fliggyChangeStatus(item) {
      const newStatus = item.status === 0 ? 1 : 0;
      if (newStatus === 0) {
        this.$confirm('禁用后，飞猪订单将无法自动同步，确定要禁用吗？', '禁用该店铺？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          Http.post('/peer_ota_status_switch', { status: newStatus, id: item.id })
            .then(() => {
              item.status = newStatus;
              this.$message({
                message: '禁用成功',
                type: 'success',
              });
            })
            .catch((e) => {
              console.log(e);
            });
        }).catch(() => {

        });
      } else {
        Http.post('/peer_ota_status_switch', { status: newStatus, id: item.id })
          .then(() => {
            item.status = newStatus;
            this.$message({
              message: '启用成功',
              type: 'success',
            });
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    // 删除飞猪店铺
    fliggyDelete(e, id) {
      sensorsdata.quick('trackHeatMap', e.target);
      Http.post('/peer_ota_delete', { id }, { noToast: true })
        .then(() => {
          this.$message({
            message: '删除成功',
            type: 'success',
          });
          this.getFliggyShopList();
        })
        .catch((e) => {
          console.log(e);
          this.$alert(e.msg, '店铺无法删除', {
            confirmButtonText: '知道了',
          });
        });
    },
    gotoOrders() {
      this.$router.push({ name: 'orders', query: { order_type_id: '1' } });
    },

    // 显示修改同步状态弹窗
    onShowSyncStatusDialog(item) {
      this.syncStatusDialog.shopItem = item;
      this.syncStatusDialog.visible = true;
    },
    // 修改同步状态成功
    onChangeSyncSuccess(value) {
      this.syncStatusDialog.shopItem.sync_type_id = value;
    },
    
  },
  created() {
    // 判断授权跳转回的错误信息
    if (this.$route.query.alitrip_auth === 'ok') {
      this.$message({
        message: '授权成功',
        type: 'success',
      });
      this.$router.replace({ query: {} });
    } else if (this.$route.query.alitrip_auth) {
      this.$message({
        message: `${this.$route.query.alitrip_auth}（在3秒后自动注销淘宝登录）`,
        type: 'error',
      });
      this.$router.replace({ query: {} });
      setTimeout(() => {
        window.location.href = 'https://oauth.taobao.com/logoff?client_id=26051121&view=web';
      }, 4000);
    }
    // 拉取飞猪店铺列表
    this.getFliggyShopList();
  },
};
</script>

<style lang="less" scoped>
.shop-page{
  padding: 24px;
  .page-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    .fliggy-document{
      display: flex;
      align-items: center;
      cursor: pointer;
      .icon{
        width: 26px;
        height: 22px;
      }
      .text{
        font-size: 16px;
        color: #599FFF;
        margin-left: 4px;
      }
    }
    .add-box{
      .add-btn{
      }
    }
  }
  .table-box{
    margin-top: 24px;
    width:100%;
		font-size: 14px;
    border: none;
    color: #2F333D;
    thead{
      border:1px solid #E9EEF2;
      th{
        background-color: #FAFBFC;
        padding: 0 8px;
        text-align: left;
        font-weight: 600;
        height: 60px;
        &:first-child{
          padding-left: 16px;
        }
      }
    }
    tbody{
      tr{
        border-bottom: 1px solid #E9EEF2;
        td{
          padding: 16px 8px;
          height:68px;
			    background-color: #fff;
          word-break: break-all;
          &:first-child{
            padding-left: 16px;
          }
        }
      }
    }
    .text-center{
      text-align: center;
    }
    .color-red{
      color: #F4455C;
    }
    .sync-status-box{
      display: flex;
      align-items: center;
      color: #2F333D;
      font-size: 14px;
      .edit-icon{
        width: 16px;
        height: 16px;
        margin-left: 8px;
        cursor: pointer;
      }
    }
    .btn{
      display: inline-block;
      color: #599FFF;
      font-size: 14px;
      cursor: pointer;
      &+.btn{
        margin-left: 12px;
      }
    }
  }

  .nodata-box{
    margin-top: 32px;
    width: 100%;
    border: 1px solid #DEE2E6;
    padding: 24px 32px 68px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    .nodata-title{
      color: #2F333D;
      font-size: 18px;
      line-height: 25px;
      font-weight: 600;
      position: relative;
      &::before{
        content: "";
        width: 80px;
        height: 6px;
        background: #599FFF;
        opacity: 0.3;
        position: absolute;
        left: -2px;
        top: 13px;
      }
    }
    .step-list{
      width: 100%;
      margin-top: 48px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .step-item{
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-img{
          width: 180px;
          height: 161px;
        }
        .item-text{
          margin-top: 10px;
          text-align: center;
          color: #2F333D;
          font-size: 14px;
          line-height: 20px;
          font-weight: 600;
          .link{
            color: #599FFF;
          }
        }
      }
    }
    .nodata-img{
      width: 200px;
      height: 120px;
    }
    .nodata-text{
      color: #91999F;
      font-size: 16px;
      line-height: 24px;
      margin-top: 6px;
    }
    .add-btn{
      margin-top: 16px;
    }
    .fliggy-document{
      margin-top: 32px;
      display: flex;
      align-items: center;
      cursor: pointer;
      .icon{
        width: 26px;
        height: 22px;
      }
      .text{
        font-size: 16px;
        color: #599FFF;
        margin-left: 4px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/Shop.vue